import React from 'react'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { organizationSSOSettingsRouteProps } from 'src/navigation/routeProps'
import OrganizationSSOConfig from 'src/page-components/OrganizationSSOConfig/OrganizationSSOConfig'

const SSOSettingsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsSSO,
  routeProps: organizationSSOSettingsRouteProps,
  component: <OrganizationSSOConfig />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default SSOSettingsAppRoute
